import React, { useCallback } from "react";
import { useParams } from "react-router-dom";

import Content from "../../layout/content/Content";
import Head from "../../layout/head/Head";
import DetailsPageHeader from "../../components/shared/DetailsPageHeader";
import Fetcher from "../../components/shared/FetcherComponent";
import PartnerMainInfoBlock from "../../components/partnerPage/partnerDetailsPage/PartnerMainInfoBlock";
import PartnerDescriptionBlock from "../../components/partnerPage/partnerDetailsPage/PartnerDescriptionBlock";
import PartnerMediaBlock from "../../components/partnerPage/partnerDetailsPage/PartnerMediaBlock";

import partnerService from "../../services/partnerService";
import { usePartnerPageContext } from "../../hooks/usePartnerPageContext";
import { LANGUAGE_KEYS } from "../../utilities/constants";

const PartnerDetailsPage = () => {
  const { partnerId } = useParams();
  const { singlePartner, setSinglePartner } = usePartnerPageContext();

  const fetchPartner = useCallback(
    async () => await partnerService.getPartnerById(partnerId),
    [partnerId]
  );

  const handleOnLoadFetchedPartner = useCallback(
    (response) => setSinglePartner(response),
    [setSinglePartner]
  );

  return (
    <>
      <Head title="Partner Details" />
      <Content>
        <Fetcher action={fetchPartner} onLoad={handleOnLoadFetchedPartner}>
          <DetailsPageHeader
            title={"Partner -"}
            name={singlePartner?.name?.[LANGUAGE_KEYS.EN]}
            createdDate={singlePartner?.createdAt}
            goBackPath={"/partners"}
          />
          <PartnerMainInfoBlock />
          <PartnerDescriptionBlock />
          <PartnerMediaBlock />
        </Fetcher>
      </Content>
    </>
  );
};

export default PartnerDetailsPage;
